export const drawText = (context, obj, canvasOffset, zoom) => {
  const centerX = obj.x + obj.width / 2;
  const centerY = obj.y + obj.height / 2;

  context.save(); // Save the current state
  context.scale(zoom, zoom);
  context.translate(centerX + canvasOffset.x, centerY + canvasOffset.y); // Move to the center of the rectangle
  context.rotate((obj.rotation * Math.PI) / 180); // Rotate around the center

  // Draw the rectangle
  context.fillStyle = "transparent";
  context.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
  // zoom >= 0.4 ? obj.fontSize / zoom :
  const newFont =  obj.fontSize;
  // Before drawing the text, rotate back to cancel out the rectangle's rotation
  // context.rotate((-obj.rotation * Math.PI) / 180); // Inverse rotation for the text
  context.fillStyle = obj.color; // Set text color
  if(obj.fontColor) context.fillStyle = obj.fontColor;
  context.font = `${newFont}px Arial`; // Set font size and family
  context.textAlign = "center"; // Center the text horizontally
  context.textBaseline = "middle"; // Center the text vertically
  context.fillText(obj.name, 0, 0); // Draw the text at the rectangle's center

  context.restore(); // Restore the initial context state
};
